export const TransaksiJurnalSorting = () => {
  return [
    {
      id: "sortingCol",
      label: "Sorting By",
      options: [
        {
          label: "Created At",
          value: 0,
        },
        {
          label: "Tanggal Transaksi",
          value: 1,
        },
        {
          label: "Nomor Transaksi Jurnal",
          value: 2,
        },
      ],
    },
  ];
};
